import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/components/index'
import Investment from '@/components/investment'
import investmentDetails from '@/components/investmentDetails'
import CustomProduct from '@/components/customProduct'
import About from '@/components/about'
import Activity from '@/components/activity'
Vue.use(Router)

export default new Router({
  routes: [
		{path: '*',redirect: '/Index'},
    {
      path: '/Index',
      // name:Index,
      component: Index,
      meta:{
        title:'首页',
        requiresAuth:true
      }
    },
    {
      path: '/Investment',
      // name:Investment,
      component: Investment,
      meta:{
        title:'商业模式',
        requiresAuth:true
      }
    },
    {
      path: '/investmentDetails',
      // name:Investment,
      component: investmentDetails,
      meta:{
        title:'案例详情',
        requiresAuth:true
      }
    },
    {
      path: '/CustomProduct',
      // name:CustomProduct,
      component: CustomProduct,
      meta:{
        title:'定制产品',
        requiresAuth:true
      }
    },
    {
      path: '/About',
      // name:About,
      component: About,
      meta:{
        title:'关于我们',
        requiresAuth:true
      }
    },
    {
      path: '/Activity',
      // name:Activity,
      component: Activity,
      meta:{
        title:'最新活动',
        requiresAuth:true
      }
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js